import "./NavPanel.css";
import { NavLink } from "react-router-dom";
import Action from "./../formElements/Action/Action";
import { useTranslation } from "react-i18next";
import { Tab } from "hooks/useTabs";

type Props = {
  activeColor?: string;
  smallWindow?: boolean;
  tabs: Tab[];
  linkClassName?: string;
  footer?: boolean;
};

const NavPanel = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#01bcd4";

  let tabsItems = null;
  if (!props.smallWindow) {
    tabsItems = (props.tabs || []).map(tab => {
      if (props.footer && tab.asIcon) {
        // Don't render icon elements in the footer.
        return null;
      }

      const innerItem = <NavPanelInnerItem tab={tab} />;

      let linkClassName = props.linkClassName + (tab && tab.asIcon ? " as-icon" : "");

      const getPath = (path: string) => {
        if (path === "/dashboard") {
          if (window.location.pathname === "/") {
            return "/";
          }
        } else if (window.location.pathname.includes(path)) {
          if (path !== "/admin") {
            return path;
          } else if (
            window.location.pathname !== "/admin/content" &&
            window.location.pathname !== "/admin/settings"
          ) {
            return path;
          }
        }
        if (window.location.pathname.includes("/course")) {
          return "/library";
        }
      };

      if (tab && tab.path) {
        let linkActiveClassName =
          getPath(tab.path === "/" ? "/dashboard" : tab.path) === tab?.path
            ? "selected"
            : "unselected";
        return (
          <NavLink
            end
            key={tab.name}
            to={tab.path}
            style={
              linkActiveClassName === "selected" ? { borderBottomColor: activeColor } : {}
            }
            className={linkActiveClassName}
          >
            {innerItem}
          </NavLink>
        );
      } else if (tab && tab.absolutePath) {
        return (
          <a
            href={tab.absolutePath}
            key={tab.name}
            className={linkClassName}
            target={tab.external ? "_blank" : "_self"}
            rel="noreferrer"
          >
            {innerItem}
          </a>
        );
      } else if (tab && tab.onClick) {
        return (
          <Action key={tab.name} className={linkClassName} onClick={tab.onClick}>
            {innerItem}
          </Action>
        );
      } else {
        return null;
      }
    });
  } else {
    return null;
  }

  return <nav className="tabs">{tabsItems}</nav>;
};

interface INavPanelInnerItem {
  tab: Tab;
}

const NavPanelInnerItem = (props: INavPanelInnerItem) => {
  const { ready, t } = useTranslation("translation", { useSuspense: false });

  if (!props.tab) {
    return null;
  }
  let item = null;
  if (props.tab.asIcon && props.tab.icon) {
    // If nav tab is supposed to be rendered as icon, then render <img>.
    item = props.tab.icon;
  } else {
    // Otherwise render just text.
    item = ready ? t(props.tab.title) : "";
  }

  return <>{item}</>;
};
export default NavPanel;
